"use strict";

//Modules

//Components
import Header from './components/header';
import AOS from 'aos';
import Formularios from './components/form_wpforms';
import ModFullSlider from './modulos/modulo-full_slider';
import ModSliderServicos from './modulos/modulo-slider_servicos';
import ModSliderUnidades from './modulos/modulo-slider_unidades';
import ModTextoComTopicos from './modulos/modulo-texto_com_topicos';
import ModSliderGaleriaUnidades from './modulos/modulo-galeria_de_unidade';

export default class App {
    constructor(){

        //Parts
        new Header()

        AOS.init({
            duration: 1500
        });
        
        const ModuloFullSlider = document.querySelector('.modulo-full_slider')
        const ModuloSliderServicos = document.querySelector('.modulo-slider_servicos')
        const ModuloSliderUnidades = document.querySelector('.modulo-slider_unidades')
        const ModuloTextoComTopicos = document.querySelector('.modulo-texto_com_topicos')
        const ModuloGaleriaUnidades = document.querySelector('.modulo-galeria_de_unidade')

        ModuloFullSlider ? new ModFullSlider() : null
        ModuloSliderServicos ? new ModSliderServicos() : null
        ModuloSliderUnidades ? new ModSliderUnidades() : null
        ModuloTextoComTopicos ? new ModTextoComTopicos() : null
        ModuloGaleriaUnidades ? new ModSliderGaleriaUnidades() : null

    }
}

new App();